import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatCheckbox } from '@angular/material/checkbox';
import { DatepickerHeaderComponent } from '../datepicker-header/datepicker-header.component';
import { TableInputFieldVariant } from '../../enums/TableInputFieldVariant.enum';
import { SelectOption } from '../../interfaces/ISelectOption';

@Component({
  selector: 'app-table-input-field',
  templateUrl: 'table-input-field.component.html',
  styleUrls: ['table-input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatSelect,
    MatOption,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    CdkTextareaAutosize,
    MatCheckbox,
  ],
})
export class TableInputFieldComponent<T> {
  @Input() rowValue: T;
  @Input() inputVariant: TableInputFieldVariant;
  @Input() options: SelectOption[];
  @Input() disabled = false;
  @Output() modelChange: EventEmitter<T> = new EventEmitter<T>();
  @Output() modelBlur: EventEmitter<T> = new EventEmitter<T>();
  protected readonly DatepickerHeaderComponent = DatepickerHeaderComponent;

  protected onRowValueChange(rowValue: T): void {
    this.rowValue = rowValue;
    this.modelChange.emit(this.rowValue);
  }

  protected onBlur(): void {
    this.modelBlur.emit(this.rowValue);
  }
}
